/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/8/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {Type} from "@qwoach/class-transformer-wrapper";
import ReminderItem from "@shared/scheduler/reminders/ReminderItem";
import QwoachFileRef from "@shared/Drive/QwoachFileRef";

export default class SendingReminderWrapper extends BaseObject {

	@Type(() => QwoachFileRef)
	filesRefArray: QwoachFileRef[] = []

	@Type(() => ReminderItem)
	initialReminder: ReminderItem = null

	@Type(() => ReminderItem)
	followups: ReminderItem[] = []


	constructor() {
		super();
	}

	pushFileRefsArray(fileRefArray){
		for(let fileRef of fileRefArray){
			this.pushFileRef(fileRef)
		}
	}

	pushFileRef(fileRef){
		let index = this.filesRefArray.findIndex(ref => ref.id === fileRef.id)
		if(index >= 0){
			this.filesRefArray.splice(index, 1, fileRef)
		} else {
			this.filesRefArray.push(fileRef)
		}
	}

	getAllFilesRefs(){
		return this.filesRefArray
	}

	setFilesRefs(filesRefArray){
		this.filesRefArray = filesRefArray
	}

	getFileRefById(fileId){
		let index = this.filesRefArray.findIndex(fileRef => fileRef.id === fileId)
		if(index >= 0){
			return this.filesRefArray[index]
		}
		return null
	}

	getLegalDocTemplatesFileRefs(){
		return this.filesRefArray.filter(fileRef => fileRef.isLegalDocTemplate())
	}
	getLegalDocsFileRefs(){
		return this.filesRefArray.filter(fileRef => fileRef.isLegalDoc() || fileRef.isLegalDocTemplate())
	}
	getNonLegalDocsFileRefs(){
		return this.filesRefArray.filter(fileRef => !fileRef.isLegalDoc() && !fileRef.isLegalDocTemplate())
	}
	getFormsFileRefs(){
		return this.filesRefArray.filter(fileRef => fileRef.isForm())
	}
	getDriveFilesRefs(){
		return this.filesRefArray.filter(fileRef => fileRef.isDriveFile())
	}

}
